import { LoggerPayload } from 'libs/end-to-end/src/isomorphic-logger';

export const calcPayGap = ({
  currentSalary,
  marketSalary,
}: {
  currentSalary: number;
  marketSalary: number;
}) => {
  return ((currentSalary - marketSalary) / currentSalary) * 100;
};

interface PayGapEmployee {
  adjustedSalary: number;
  marketSalary: number;
}

export const calcPayGapGroup = ({
  employees,
  logger,
}: {
  employees: PayGapEmployee[];
  logger: LoggerPayload;
}) => {
  if (!employees.length) {
    logger.info('calcPayGapGroup: no employees');
    return 0;
  }

  let pctSum = 0;

  for (const emp of employees) {
    pctSum += calcPayGap({
      currentSalary: emp.adjustedSalary,
      marketSalary: emp.marketSalary,
    });
  }

  return pctSum / employees.length;
};
